var _style, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryCars = function SvgCategoryCars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_cars_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_cars_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_cars_svg__st0",
    d: "m10.1 29.3-.9-.4c-1.4-.6-2.4-2-2.4-3.6v-1.4c0-.7.3-1.4.8-1.9l2.3-2c2.5-2.4 6-3.7 9.5-3.6l4.5.1c.6 0 1.3.2 1.8.5l6.9 4c.6.4 1.3.5 2 .7.3 0 .5.1.7.1h1.5c.9 0 1.7.3 2.4.7l2.7 1.8c.7.5 1.1 1.3 1.1 2.1v.4c0 .5-.2 1-.5 1.4l-.5.5c-.4.5-.9.6-1.4.6h-3.2M8.2 21.6h25.9M16.8 29.3H31"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "category_cars_svg__st0",
    cx: 13.6,
    cy: 29.3,
    r: 3.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "category_cars_svg__st0",
    cx: 34.4,
    cy: 29.3,
    r: 3.1
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "m19.1 16.7.6 10h7.7"
  }));
};
export default SvgCategoryCars;